import styled from 'styled-components'


export const HeroContainer = styled.div`
    background = #0c0c0c;
    display: flex; 
    justify-content: center;
    align-items: center;
    padding: 0 30px;
    margin-top: -80px;
    height: 1080px;
    position: relative;
    z-index: 1;
    

    /*:before{
        content: '';
        position: absolute;
        top: 0;
        left: 0;
        right: 0;
        bottom: 0;
        background: linear-gradient(
            180deg, 
            rgba(0,0,0,0.2) 0%, 
            rgba(0,0,0,0.6) 100%
            ),
            linear-gradient(180deg, rgba(0,0,0,0.2) 0%, transparent 100%);
        z-index: 2;
    }*/

`

export const HeroBg = styled.div`
    position: absolute;
    top: 0;
    right: 0;
    bottom: 0;
    left: 0;
    width: 100%;
    height: 100%;
    overflow: hidden;
`

export const DarkOverlay = styled.div`
    position: absolute;
    top: 0;
    left: 0;
    width: 100%;
    height: 100%;
    background: linear-gradient(rgba(18, 86, 107, 0.6), rgba(38, 120, 150, 0.3)); /* Gradient from 50% opacity at top to 30% opacity at bottom */
`;
export const VideoBg = styled.video`
    width: 100%;
    height: 100%;
    -o-object-fit: cover;
    object-fit: cover;
    background-image: #fff;
`
export const HeroContent = styled.div`
    z-index = 3;
    max-width 1200px;
    position: absolute;
    padding 8px 24px;
    display: flex;
    flex-direction: column;
    align-items: center;
`

export const HeroH1 = styled.h1`
    color: #fff;
    font-size: 90px;
    text-align: center;

    @media screen and (max-width: 768px){
        font-size: 60px;
    }

    @media screen and (max-width: 480px){
        font-size: 32px;
    }
`

export const HeroBtnWrapper = styled.div`
    margin-top: 32px;
    display: flex;
    flex-direction: column;
    align-items: center;
`
